<template>
  <section id="faq" class="faq-subsection">
    <h2 class="section-title">Questions Fréquentes</h2>
    <div class="faq-list">
      <div v-for="(item, idx) in faqs" :key="item.q" class="faq-item" :class="{ 'first-open': idx === 0 }">
        <button
          class="faq-header"
          type="button"
          :aria-expanded="isOpen(idx)"
          @click="toggle(idx)"
        >
          <span class="faq-question">{{ item.q }}</span>
          <span class="chevron" :class="{ open: isOpen(idx) }" aria-hidden="true">▼</span>
        </button>
        <div v-if="isOpen(idx)" class="faq-answer-wrapper">
          <p class="faq-answer">{{ item.a }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FAQSubsection",
  data() {
    return {
      openIndexes: [0] as number[], // First question open by default
      faqs: [
        {
          q: "Qu'est-ce qui est inclus dans l'essai gratuit ?",
          a: "Notre essai gratuit vous donne accès à toutes les fonctionnalités du plan Pro pendant 14 jours, sans aucune restriction. Vous pouvez explorer l'intégralité de la plateforme pour voir comment elle peut transformer votre commerce floral.",
        },
        {
          q: "Puis-je changer de plan à tout moment ?",
          a: "Oui, vous pouvez passer à un plan supérieur ou inférieur à tout moment. Les changements prennent effet immédiatement et sont calculés au prorata.",
        },
        {
          q: "Y a-t-il des frais cachés ou des coûts supplémentaires ?",
          a: "Non, nos tarifs sont transparents. Le prix affiché est le prix que vous payez, sans frais cachés. Seuls les services optionnels (comme la formation personnalisée) peuvent engendrer des coûts supplémentaires, mais ils sont toujours clairement indiqués.",
        },
        {
          q: "Comment le support technique fonctionne-t-il ?",
          a: "Le support technique varie selon votre plan. Le plan Basique inclut un support par email, le plan Croissance offre un support prioritaire, et le plan Premium inclut un support dédié 24/7 avec un gestionnaire de compte personnel.",
        },
        {
          q: "Puis-je annuler mon abonnement à tout moment ?",
          a: "Oui, vous pouvez annuler votre abonnement à tout moment sans frais. Votre accès restera actif jusqu'à la fin de la période de facturation en cours.",
        },
      ],
    };
  },
  methods: {
    isOpen(idx: number) {
      return this.openIndexes.includes(idx);
    },
    toggle(idx: number) {
      if (this.isOpen(idx)) {
        this.openIndexes = this.openIndexes.filter((i) => i !== idx);
        return;
      }
      this.openIndexes = [...this.openIndexes, idx];
    },
  },
});
</script>

<style>
.faq-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #f1faea;
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.faq-subsection .section-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  margin: 0;
  text-align: center;
  width: 100%;
}

.faq-subsection .faq-list {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 1000px;
  min-width: 350px;
  width: 100%;
}

.faq-subsection .faq-item {
  align-items: flex-start;
  align-self: stretch;
  border-bottom: 1.5px solid #e8ece4;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.faq-subsection .faq-item:first-child {
  border-bottom: 1px solid #e8ece4;
}

.faq-subsection .faq-header {
  all: unset;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  width: 100%;
}

.faq-subsection .faq-question {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  text-align: left;
}

.faq-subsection .chevron {
  color: #5f5f5f;
  display: inline-flex;
  font-size: 12px;
  line-height: 1;
  transform: rotate(0deg);
  transition: transform 0.18s ease;
}

.faq-subsection .chevron.open {
  transform: rotate(180deg);
}

.faq-subsection .faq-answer-wrapper {
  align-items: center;
  background-color: transparent;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 100%;
}

.faq-subsection .faq-answer {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

@media (max-width: 768px) {
  .faq-subsection .faq-list {
    min-width: 0;
  }

  .faq-subsection .section-title {
    font-size: 30px;
    line-height: 1.2;
  }

  .faq-subsection .faq-question {
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
